class HulkBuilder {
    constructor() {
        this.state = {
            optionSet: null,
            maxHolesA: 3,
            maxHolesB: 3,
            currentNavStep: 1,
            currentImage: {
                width: 2,
                length: 8,
                sideA: 0,
                sideB: 0,
                bumpers: null
            }
        };
    }

    init() {
        window.addEventListener("load", () => {
            const polling = setInterval(() => {
                const optionSet = document.querySelector("div[id^='hulkapps_custom'] .hulkapps_option_set");

                if (optionSet) {
                    clearInterval(polling);

                    this.state.optionSet = optionSet;

                    setTimeout(() => this.main(), 100);
                }
            }, 100);

            setTimeout(() => clearInterval(polling), 20000);
        });
    }

    main() {
        // this.removeAppCSS(); // DEV ONLY

        this.groupCustomElements();
        this.initSectionSwitcher();
        this.handleNextAndPrev();
        this.handleProductDescriptionPopover();
        this.addNumberInputControls();
        this.addGreenSpeedSlider();
        this.handleImageChange();
        this.createHoleToggle();
        this.createAddonToggles();
        // this.handleCupsAndFlags();
        this.handleSizeUpdate();
        this.handleBumpers();
        this.updateBumperOptions();
        this.handleLogoPreview();
        this.hideSkeletonLoader();
        this.handleAddToCart();
    }

    removeAppCSS() {
        // DEV ONLY
        const parent = this.state.optionSet.closest("div[id^='hulkapps_custom']");

        const style = parent?.querySelector("style");
        if (style) style.remove();
    }

    groupCustomElements() {
        const groups = [
            { className: "customSize", parentId: "sizes-section" },
            { className: "customFeatures", parentId: "features-section" },
            { className: "customLogo", parentId: "logo-section" },
            { className: "customAddon", parentId: "addon-section" }
        ];

        groups.forEach(group => {
            const items = document.querySelectorAll("." + group.className);

            const parent = document.createElement("div");
            parent.id = group.parentId;
            parent.classList.add("options-section");

            if (group.className === "customSize") {
                const subSectionOne = document.createElement("div");
                subSectionOne.classList.add("size-subsection-1");

                const subSectionOneTitle = document.createElement("div");
                subSectionOneTitle.textContent = "Size of the Mat";
                subSectionOneTitle.className = "size-subsection-title";
                subSectionOne.appendChild(subSectionOneTitle);

                const subSectionTwo = document.createElement("div");
                subSectionTwo.classList.add("size-subsection-2");

                items.forEach((el, index) => {
                    if (index < 1) {
                        subSectionOne.appendChild(el);
                    } else {
                        subSectionTwo.appendChild(el);
                    }
                });

                parent.appendChild(subSectionOne);
                parent.appendChild(subSectionTwo);

                const legend = document.createElement("div");
                legend.className = "size-legend";
                legend.innerHTML = `
                    <div class="legend-title">Legend</div>
                    <div class="legend-item">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="#000000" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M14 12.0001C14 13.1046 13.1046 14.0001 12 14.0001C10.8954 14.0001 10 13.1046 10 12.0001C10 10.8955 10.8954 10.0001 12 10.0001C13.1046 10.0001 14 10.8955 14 12.0001Z" />
                                <path d="M8 6.99997C8 6.99997 10.946 3.00001 12 3C13.0541 2.99999 16 7 16 7" />
                                <path d="M16 17C16 17 13.054 21 12 21C10.9459 21 8 17 8 17" />
                            </svg>
                        </span>
                        <span>Width</span>
                    </div>
                    <div class="legend-item">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="#000000" fill="none" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M16.5001 3.26621C17.3445 3.25421 20.141 2.67328 20.7339 3.26621C21.3268 3.85913 20.7459 6.65559 20.7339 7.5" />
                                <path d="M3.26631 16.5C3.25431 17.3444 2.67338 20.1409 3.26631 20.7338C3.85923 21.3267 6.65569 20.7458 7.5001 20.7338" />
                                <path d="M3.89561 20.0577L20.1047 3.94238" />
                            </svg>
                        </span>
                        <span>Length</span>
                    </div>
                `;

                parent.appendChild(legend);
            } else if (group.className === "customFeatures") {
                const subSectionOne = document.createElement("div");
                subSectionOne.classList.add("features-subsection-1");

                const subSectionOneTitle = document.createElement("div");
                subSectionOneTitle.textContent = "Hole & Flag Location";
                subSectionOneTitle.className = "features-subsection-title";
                subSectionOne.appendChild(subSectionOneTitle);

                const subSectionTwo = document.createElement("div");
                subSectionTwo.classList.add("features-subsection-2");

                items.forEach((el, index) => {
                    if (index < 3) {
                        subSectionOne.appendChild(el);
                    } else {
                        subSectionTwo.appendChild(el);
                    }
                });

                parent.appendChild(subSectionOne);
                parent.appendChild(subSectionTwo);
            } else if (group.className === "customLogo") {
                const subSectionOne = document.createElement("div");
                subSectionOne.classList.add("logo-subsection-1");

                const subSectionTwo = document.createElement("div");
                subSectionTwo.classList.add("logo-subsection-2");

                const logoTitle = document.createElement("div");
                logoTitle.textContent = "Mat Surface and Flag Pins Customization";
                logoTitle.className = "logo-subsection-title";
                subSectionOne.appendChild(logoTitle);

                items.forEach((el, index) => {
                    subSectionOne.appendChild(el);
                });

                subSectionTwo.innerHTML = `
                    <div class="logo-subsection-title">Flag Pin Preview</div>
                    <div class="flag-logo-preview">
                        <img alt="Flag pin preview" src="https://cdn.shopify.com/s/files/1/0514/6833/7337/files/Gemini_Generated_Image_4ueaow4ueaow4uea-cutout.png?v=1770556128" />
                        <img alt="" src="" />
                    </div>
                `;

                parent.appendChild(subSectionOne);
                parent.appendChild(subSectionTwo);
            } else if (group.className === "customAddon") {
                const subSectionOne = document.createElement("div");
                subSectionOne.classList.add("addon-subsection-1");

                const addonTitle = document.createElement("div");
                addonTitle.textContent = "Available Add-ons";
                addonTitle.className = "addon-subsection-title";
                subSectionOne.appendChild(addonTitle);

                const subSectionTwo = document.createElement("div");
                subSectionTwo.classList.add("addon-subsection-2");

                const addonImgUrls = [
                    "https://cdn.shopify.com/s/files/1/0514/6833/7337/products/shimlayout1080x1080white.jpg?v=1615480380",
                    "https://cdn.shopify.com/s/files/1/0514/6833/7337/products/putting-mats-zip-bag__91124.1579966696.1280.1280.jpg?v=1618427471",
                    "https://cdn.shopify.com/s/files/1/0514/6833/7337/products/brush_website_final__46383.1596731280.1280.1280_91a7596f-1f31-4c49-90b5-28542c70e2dd.jpg?v=1649028932",
                    "https://cdn.shopify.com/s/files/1/0514/6833/7337/products/mirrorclean.jpg?v=1615480049"
                ];

                items.forEach((el, index) => {
                    const addonImgContainer = document.createElement("div");
                    addonImgContainer.className = "addon-img";
                    const addonImg = document.createElement("img");
                    addonImg.src = addonImgUrls[index];
                    
                    addonImgContainer.appendChild(addonImg);
                    el.prepend(addonImgContainer);

                    if (index < 2) {
                        subSectionOne.appendChild(el);
                    } else {
                        subSectionTwo.appendChild(el);
                    }
                });

                parent.appendChild(subSectionOne);
                parent.appendChild(subSectionTwo);
            }

            this.state.optionSet.appendChild(parent);
        });
    }

    initSectionSwitcher() {
        const navButtons = document.querySelectorAll(".nav-element");
        const sections = this.state.optionSet.querySelectorAll(".options-section");

        if (!navButtons.length || !sections.length) return;

        const showSection = (id) => {
            sections.forEach(sec => {
                sec.classList.remove("active");
                void sec.offsetWidth; // Force repaint
            });

            const target = document.getElementById(id);
            if (target) target.classList.add("active");
        }

        navButtons.forEach((btn, index) => {
            btn.addEventListener("click", () => {
                navButtons.forEach(b => b.classList.remove("active"));
                btn.classList.add("active");

                this.state.currentNavStep = index + 1;
                
                this.updateButtonStates(this.state.currentNavStep);
                this.validateCurrentStep(); // <--- Added validation hook

                const target = btn.getAttribute("data-target");
                if (target) showSection(target);
            });
        });

        navButtons[0].click(); 
    }

    updateButtonStates(step) {
        const prevBtn = document.getElementById("btn-prev");
        const nextBtn = document.getElementById("btn-next");
        const atcBtn = document.getElementById("btn-atc");

        if (step === 1) {
            prevBtn.classList.add("disabled");
        } else {
            prevBtn.classList.remove("disabled");
        }

        if (step === 4) {
            nextBtn.classList.remove("active");
            atcBtn.classList.add("active");
        } else {
            atcBtn.classList.remove("active");
            nextBtn.classList.add("active");
        }
    }

    validateCurrentStep() {
        const nextBtn = document.getElementById("btn-next");
        const navButtons = document.querySelectorAll(".nav-element");
        
        let isValid = true;

        if (this.state.currentNavStep === 1) {
            isValid = !!(this.state.currentImage.width && this.state.currentImage.length);
        } else if (this.state.currentNavStep === 2) {
            const holeCutterContainer = this.state.optionSet.querySelector(".hole-cutter .hulkapps_check_option .hulkapps-custom-check");
            const isHoleCutterChecked = holeCutterContainer && holeCutterContainer.previousElementSibling ? holeCutterContainer.previousElementSibling.checked : false;
            
            const sideA = parseInt(this.state.currentImage.sideA) || 0;
            const sideB = parseInt(this.state.currentImage.sideB) || 0;
            const hasHoles = isHoleCutterChecked || (sideA > 0 || sideB > 0);

            const bumperSelect = this.state.optionSet.querySelector(".features-subsection-2 .dd_render select");
            const isBumperSelected = bumperSelect ? bumperSelect.value.trim() !== "" : false;

            isValid = hasHoles && isBumperSelected;
        }

        if (isValid) {
            nextBtn.classList.remove("disabled");
        } else {
            nextBtn.classList.add("disabled");
        }

        navButtons.forEach((btn, index) => {
            const stepNumber = index + 1;
            
            if (stepNumber < this.state.currentNavStep) {
                btn.classList.remove("disabled");
            } else if (stepNumber === this.state.currentNavStep) {
                btn.classList.remove("disabled");
            } else if (stepNumber === this.state.currentNavStep + 1) {
                if (isValid) {
                    btn.classList.remove("disabled");
                } else {
                    btn.classList.add("disabled");
                }
            } else {
                btn.classList.add("disabled");
            }
        });
    }

    handleNextAndPrev() {
        const navButtons = document.querySelectorAll(".nav-element");

        document.getElementById("btn-prev").addEventListener("click", () => {
            if (this.state.currentNavStep > 1) {
                navButtons[this.state.currentNavStep - 2].click();
            }
        });

        document.getElementById("btn-next").addEventListener("click", (e) => {
            if (e.currentTarget.classList.contains("disabled")) return;

            if (this.state.currentNavStep < 4) {
                navButtons[this.state.currentNavStep].click();
            }
        });
    }

    handleProductDescriptionPopover() {
        const btn = document.getElementById("popover-btn");
        const popover = document.getElementById("popover-content");

        btn.addEventListener("click", (e) => {
            e.stopPropagation();
            popover.classList.toggle("hidden");
        });

        window.addEventListener("click", () => {
        if (!popover.classList.contains("hidden")) {
            popover.classList.add("hidden");
        }
        });

        popover.addEventListener("click", (e) => {
            e.stopPropagation();
        });
    }

    addNumberInputControls() {
        this.state.optionSet.querySelectorAll(".hulkapps_option.nf_render .hulkapps_option_value").forEach(el => {
            const side = el.previousElementSibling.getAttribute("aria-label").trim();

            const input = el.querySelector("input");
            input.readOnly = true;
            input.value = 0;

            const minusBtn = document.createElement("button");
            minusBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="11" height="11" color="currentColor" fill="none" stroke="#141B34" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 12L4 12" />
                </svg>
            `;
            minusBtn.className = "qty-btn minus";
            minusBtn.type = "button";

            const plusBtn = document.createElement("button");
            plusBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="11" height="11" color="currentColor" fill="none" stroke="#141B34" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 4V20M20 12H4" />
                </svg>
            `;
            plusBtn.className = "qty-btn plus";
            plusBtn.type = "button";

            minusBtn.addEventListener("click", () => {
                let currentValue = parseInt(input.value) || 0;
                if (currentValue > 0) {
                    input.value = currentValue - 1;
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                    this.updateHoles(side, currentValue - 1);
                }
            });

            plusBtn.addEventListener("click", () => {
                let currentValue = parseInt(input.value) || 0;
                const maxHoles = side === "Side A" ? this.state.maxHolesA : this.state.maxHolesB;
                if (currentValue < maxHoles) {
                    input.value = currentValue + 1;
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                    this.updateHoles(side, currentValue + 1);
                }
            });

            el.prepend(minusBtn);
            el.appendChild(plusBtn);
        });
    }

    addGreenSpeedSlider() {
        const container = this.state.optionSet.querySelector(".green-speed .hulkapps_option_value");
        const radioIds = ["1662920_0", "1662920_1", "1662920_2"];
        
        const tooltips = [
            "9-10 Stimp | Public Municipal",
            "10-11 Stimp | Private Course",
            "11-13 Stimp | Championship Course"
        ];

        const sliderWrapper = document.createElement("div");
        sliderWrapper.className = "custom-slider-wrapper";
        sliderWrapper.innerHTML = `
            <div class="slider-labels">
                <span class="s-label" data-index="0" data-tooltip="${tooltips[0]}">Slow</span>
                <span class="s-label" data-index="1" data-tooltip="${tooltips[1]}">Med</span>
                <span class="s-label" data-index="2" data-tooltip="${tooltips[2]}">Fast</span>
            </div>
            <div class="slider-wrapper">
                <div class="slider-container" id="sliderContainer">
                    <div class="slider-track-bg"></div>
                    <div class="slider-fill" id="sliderFill"></div>
                    <div class="slider-thumb" id="sliderThumb"></div>
                </div>
            </div>
        `;

        container.appendChild(sliderWrapper);

        const containerEl = sliderWrapper.querySelector("#sliderContainer");
        const thumb = sliderWrapper.querySelector("#sliderThumb");
        const fill = sliderWrapper.querySelector("#sliderFill");
        const labels = sliderWrapper.querySelectorAll(".s-label");

        let isDragging = false;

        const setVisuals = (percent, snap = false) => {
            if (snap) {
                containerEl.classList.remove("is-dragging");
            } else {
                containerEl.classList.add("is-dragging");
            }

            let visualPercent = percent;
            if (percent === 0) visualPercent = 2;
            else if (percent === 100) visualPercent = 98;
            
            thumb.style.left = `${visualPercent}%`;
            fill.style.width = `${visualPercent}%`;

            const closestIndex = Math.round((percent / 100) * 2);
            labels.forEach((l, i) => l.classList.toggle("active", i === closestIndex));
        };

        const syncHulkApps = (index) => {
            const targetRadio = document.getElementById(radioIds[index]);
            if (targetRadio) {
                targetRadio.click();
                targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        };

        const getPercentageFromEvent = (e) => {
            const rect = containerEl.getBoundingClientRect();
            const clientX = e.touches ? e.touches[0].clientX : e.clientX;
            let offset = (clientX - rect.left) / rect.width;
            return Math.max(0, Math.min(1, offset)) * 100;
        };

        labels.forEach(label => {
            label.addEventListener("click", () => {
                const index = parseInt(label.dataset.index);
                setVisuals(index * 50, true);
                syncHulkApps(index);
            });
        });

        const onStart = (e) => {
            isDragging = true;
            const p = getPercentageFromEvent(e);
            setVisuals(p);
            if (e.type === 'mousedown') e.preventDefault(); 
        };

        const onMove = (e) => {
            if (!isDragging) return;
            const p = getPercentageFromEvent(e);
            setVisuals(p);
        };

        const onEnd = (e) => {
            if (!isDragging) return;
            isDragging = false;
            
            const currentP = parseFloat(thumb.style.left);
            const closestIndex = Math.round((currentP / 100) * 2);
            
            setVisuals(closestIndex * 50, true);
            syncHulkApps(closestIndex);
        };

        containerEl.addEventListener("mousedown", onStart);
        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseup", onEnd);

        containerEl.addEventListener("touchstart", onStart, { passive: false });
        window.addEventListener("touchmove", onMove, { passive: false });
        window.addEventListener("touchend", onEnd);

        setVisuals(50, true);
    }

    handleImageChange() {
        const $slider = $(".slick-track").closest(".slick-slider");
        if (!$slider.length || !this.state.optionSet) return;

        const goToImage = () => {
            const width = this.state.currentImage.width;
            const length = this.state.currentImage.length;
            
            let sideA = parseFloat(this.state.currentImage.sideA) || 0;
            let sideB = parseFloat(this.state.currentImage.sideB) || 0;
            
            const bumpers = this.state.currentImage.bumpers;

            let value = "";

            if (width && length) {
                value = width + "x" + 14;

                let sideABVal;
                if (sideB > sideA) {
                    sideABVal = `${sideB}A${sideA}B`;
                } else {
                    sideABVal = `${sideA}A${sideB}B`;
                }
                
                value += "_" + sideABVal;

                if (bumpers) {
                    value += "_" + bumpers;
                }

                console.log("Searching for alt text containing:", value);
            }

            let targetIndex = -1;
            $slider.find(".slick-slide").each(function () {
                const img = this.querySelector("img");
                if (!img) return;

                if (img.alt.trim().includes(value)) {
                    targetIndex = $(this).data("slick-index");
                    return false;
                }
            });

            if (targetIndex !== -1) {
                $slider.slick("slickGoTo", targetIndex);
            }
        };

        this.state.optionSet
            .querySelectorAll(".hulkapps_option.rb_render.customSize .radio_div")
            .forEach(radio => {
                if (radio.dataset.slickBound) return;
                radio.dataset.slickBound = "true";
                const isWidth = radio.closest(".hulkapps_option")?.classList.contains("width_ra");

                radio.addEventListener("click", () => {
                    const val = (radio.dataset.value || radio.textContent.trim()).replace(/\D+/g, "");
                    if (isWidth) {
                        this.state.currentImage.width = parseInt(val);
                        this.state.currentImage.length = null;
                    } else {
                        this.state.currentImage.length = parseInt(val);
                    }

                    this.validateCurrentStep();

                    goToImage();
                });
            });

        this.state.optionSet
            .querySelectorAll(".hulkapps_option.nf_render input[type='number']")
            .forEach(input => {
                if (input.dataset.slickBound) return;
                input.dataset.slickBound = "true";
                const isSideA = input.nextElementSibling.name.includes("Side A");

                input.addEventListener("change", (e) => {
                    const val = e.target.value; 
                    isSideA 
                        ? this.state.currentImage.sideA = parseInt(val) || 0 
                        : this.state.currentImage.sideB = parseInt(val) || 0;
                    
                    this.validateCurrentStep();
                    goToImage();
                });
            });
        
        const bumperSelect = this.state.optionSet.querySelector(".hulkapps_option.dd_render select");
        if (bumperSelect) {
            bumperSelect.addEventListener("change", (e) => {    
                const rawValue = e.target.value.split('[')[0]; 

                const cleanValue = rawValue
                    .replace(/[^a-zA-Z0-9 ]/g, "")
                    .trim()
                    .replace(/^\d+/, "")
                    .replace(/\s+/g, "");

                this.state.currentImage.bumpers = cleanValue || "";
                
                this.validateCurrentStep();
                goToImage();
            });
        }
    }

    createHoleToggle() {
        this.state.optionSet.querySelector(".hole-cutter .hulkapps_option_name > div").textContent += " (+$25)";

        const container = this.state.optionSet.querySelector(".hole-cutter .hulkapps_check_option .hulkapps-custom-check");
        if (!container) return;
        
        container.innerHTML = `
            <div class="main-wrapper">
                <div class="off">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="8" height="8" color="#000000"
                        fill="none" stroke="#000000" stroke-width="4" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                </div>
                <div class="pin">
                    <div></div>
                </div>
                <div class="on">
                    <div></div>
                </div>
            </div>
        `;

        const tooltipEl = document.createElement("div");
        tooltipEl.className = "hole-cutter-tooltip";
        tooltipEl.innerHTML = `
            <span>I want to cut my own holes</span>
            <span>(comes with 3 cups/flags)</span>
        `;

        container.parentElement.appendChild(tooltipEl);

        container.previousElementSibling.addEventListener("change", e => {
            if (e.target.checked) {
                container.style.setProperty("border-color", "#92c83e", "important");
                container.style.setProperty("background", "rgba(156, 198, 93, .1)", "important");
                container.querySelector(".main-wrapper").style.transform = "translateX(-33px)";

                this.updateHoles("Side A", 0);
                this.updateHoles("Side B", 0);
                this.state.currentImage.sideA = 0;
                this.state.currentImage.sideB = 0;

                this.state.optionSet.querySelectorAll(".features-subsection-1 .nf_render").forEach(op => {
                    op.classList.add("disabled");
                    op.querySelector("input[type='number']").value = 0;
                    op.querySelector("input[type='hidden']").value = 0;
                });
            } else {
                container.style.setProperty("border-color", "rgba(0,0,0,.2)", "important");
                container.style.setProperty("background", "rgba(0, 0, 0, 0)", "important");
                container.querySelector(".main-wrapper").style.transform = "translateX(0)";

                this.state.optionSet.querySelectorAll(".features-subsection-1 .nf_render").forEach(op => op.classList.remove("disabled"));
            }

            this.validateCurrentStep();
        });
    }

    createAddonToggles() {
        const addonContainers = this.state.optionSet.querySelectorAll(".customAddon .hulkapps_check_option .hulkapps-custom-check");
        
        addonContainers.forEach(container => {
            container.innerHTML = `
                <div class="main-wrapper">
                    <div class="off">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="8" height="8" color="#000000"
                            fill="none" stroke="#000000" stroke-width="4" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10" />
                        </svg>
                    </div>
                    <div class="pin">
                        <div></div>
                    </div>
                    <div class="on">
                        <div></div>
                    </div>
                </div>
            `;

            const inputElement = container.previousElementSibling;

            if (inputElement && inputElement.checked) {
                container.style.setProperty("border-color", "#92c83e", "important");
                container.style.setProperty("background", "rgba(156, 198, 93, .1)", "important");
                container.querySelector(".main-wrapper").style.transform = "translateX(-33px)";
            }

            if (inputElement) {
                inputElement.addEventListener("change", e => {
                    if (e.target.checked) {
                        container.style.setProperty("border-color", "#92c83e", "important");
                        container.style.setProperty("background", "rgba(156, 198, 93, .1)", "important");
                        container.querySelector(".main-wrapper").style.transform = "translateX(-33px)";
                    } else {
                        container.style.setProperty("border-color", "rgba(0,0,0,.2)", "important");
                        container.style.setProperty("background", "rgba(0, 0, 0, 0)", "important");
                        container.querySelector(".main-wrapper").style.transform = "translateX(0)";
                    }
                });
            }
        });
    }

    handleSizeUpdate() {
        const sizePreview = document.querySelector(".size-preview");
        sizePreview.querySelector(".size-preview-element:first-child > span:nth-child(2)").textContent = this.state.currentImage.width;
        sizePreview.querySelector(".size-preview-element:nth-child(2) > span:nth-child(2)").textContent = this.state.currentImage.length;

        this.state.optionSet.querySelectorAll(`
            .hulkapps_option.rb_render.width_ra .radio_div,
            .hulkapps_option.rb_render.length_ra_2 .radio_div,
            .hulkapps_option.rb_render.length_ra_3 .radio_div,
            .hulkapps_option.rb_render.length_ra_4 .radio_div
        `).forEach(radio => {
            radio.addEventListener("click", e => {
                const val = e.target.dataset.displayVal;

                const parent = e.target.closest(".hulkapps_option.rb_render");
                if (parent.classList.contains("width_ra")) {
                    sizePreview.querySelector(".size-preview-element:first-child > span:nth-child(2)").textContent = val;
                    sizePreview.querySelector(".size-preview-element:nth-child(2) > span:nth-child(2)").textContent = "";
                } else {
                    sizePreview.querySelector(".size-preview-element:nth-child(2) > span:nth-child(2)").textContent = val;
                }

                this.updateBumperOptions();
            });
        });
    }

    updateHoles(side, quantity) {
        const preview = document.querySelector(".holes-preview");
        if (!preview) return;

        const sidePrefix = side === "Side A" ? "left" : "right";

        const sideHoles = preview.querySelectorAll(`.hole-${sidePrefix}`);
        sideHoles.forEach(hole => hole.classList.remove("active"));

        const holeMap = {
            1: ["one"],
            2: ["two-up", "two-down"],
            3: ["two-up", "two-down", "three"]
        };

        const activeSuffixes = holeMap[quantity] || [];
        activeSuffixes.forEach(suffix => {
            const selector = `.hole-${sidePrefix}-${suffix}`;
            preview.querySelector(selector)?.classList.add("active");
        });

        let total = 0;
        this.state.optionSet
            .querySelectorAll(".hulkapps_option.nf_render input[type='number']")
            .forEach(input => {
                total += parseFloat(input.value) || 0;
            });

        this.state.optionSet.querySelector(`.cups_cost label[aria-label^="${total}"]`)?.click();
    }

    handleBumpers() {
        const dropdown = this.state.optionSet.querySelector(".customFeatures > div[aria-label='Bumpers'] + div select");
        const preview = document.querySelector(".bumpers-preview");
        dropdown.addEventListener("change", e => {
            const val = e.target.value.trim().toLowerCase();

            const bumpers = preview.querySelectorAll(".bumper");
            bumpers.forEach(bum => bum.classList.remove("active"));

            if (val.includes("end bumpers")) {
                const bumper = preview.querySelector(".bumper-end");
                bumper.classList.add("active");
            } else if (val.includes("u bumpers")) {
                const bumper = preview.querySelector(".bumper-u");
                bumper.classList.add("active");
            } else if (val.includes("end + side bumpers")) {
                const bumper = preview.querySelector(".bumper-end-side");
                bumper.classList.add("active");
            }
        });
    }

    updateBumperOptions() {
        const { width, length } = this.state.currentImage;
        const selectElement = document.querySelector(".features-subsection-2 .dd_render select");
        if (!selectElement) return;

        if (!this.allBumperOptions) {
            this.allBumperOptions = Array.from(selectElement.options);
        }

        selectElement.innerHTML = "";

        this.allBumperOptions.forEach(option => {
            const val = option.value;
            let shouldShow = false;

            if (val === "" || val === "End bumpers") {
                shouldShow = true;
            } else {
                const match = val.match(/^(\d+)/);
                const optionValueNum = match ? parseInt(match[1], 10) : null;

                if (val.includes('U bumpers')) {
                    shouldShow = (optionValueNum === parseInt(width));
                } else if (val.includes('End + side bumpers')) {
                    shouldShow = (optionValueNum === parseInt(length));
                }
            }

            if (shouldShow) {
                selectElement.appendChild(option.cloneNode(true));
            }
        });

        selectElement.value = ""; 
        this.validateCurrentStep();
    }

    handleLogoPreview() {
        const fileInputs = this.state.optionSet.querySelectorAll(".customLogo input[type='file']");
        
        const logoPreviewImg = document.querySelector(".logo-preview img");
        const flagPreviewImg = document.querySelector(".flag-logo-preview img:nth-child(2)");

        fileInputs.forEach((input, index) => {
            input.addEventListener("change", () => {
                const file = input.files[0];
                if (!file || !file.type.startsWith("image/")) return;

                const reader = new FileReader();

                reader.onload = e => {
                    if (index === 0) {
                        if (logoPreviewImg) logoPreviewImg.src = e.target.result;
                    } else {
                        if (flagPreviewImg) {
                            flagPreviewImg.src = e.target.result;
                            flagPreviewImg.style.display = "block";
                        }
                    }
                };

                reader.readAsDataURL(file);
            });
        });

        this.state.optionSet.querySelectorAll(".mat_logo input[type='radio']").forEach(radio => {
            radio.addEventListener("change", e => {
                const logoPreview = document.querySelector(".logo-preview");
                if (e.target.value.startsWith("No")) {
                    logoPreview.style.display = "none";
                } else {
                    logoPreview.style.display = "block";
                }
            });
        });

        this.state.optionSet.querySelectorAll(".pin_logo input[type='radio']").forEach(radio => {
            radio.addEventListener("change", e => {
                const logoPreview = document.querySelector(".flag-logo-preview img:nth-child(2)");
                if (e.target.value.startsWith("No")) {
                    logoPreview.style.display = "none";
                } else if (flagPreviewImg.src.startsWith("data")) {
                    logoPreview.style.display = "block";
                }
            });
        });
    }

    hideSkeletonLoader() {
        const container = document.querySelector(".skeleton-container");
        setTimeout(() => container?.classList.add("fade-out"), 100);
    }

    // handleAddToCart() {
    //     const atcBtn = document.getElementById("btn-atc");
    //     if (!atcBtn) return;

    //     atcBtn.addEventListener("click", (e) => {
    //         if (atcBtn.classList.contains("is-loading")) {
    //             e.preventDefault();
    //             return;
    //         }

    //         atcBtn.classList.add("is-loading");
    //         atcBtn.style.pointerEvents = "none";
    //         atcBtn.style.opacity = "0.7";

    //         if (!atcBtn.dataset.originalHtml) {
    //             atcBtn.dataset.originalHtml = atcBtn.innerHTML;
    //         }
            
    //         atcBtn.innerHTML = `
    //             <svg class="spinner" viewBox="0 0 50 50" style="width:20px; height:20px; vertical-align:middle;">
    //                 <circle class="path" cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
    //             </svg>
    //             <span>Adding...</span>
    //         `;

    //         const originalAtc = document.querySelector(".hulkapps_submit_cart, .product-form__submit, button[name='add']");

    //         if (originalAtc) {
    //             originalAtc.click();
    //         } else {
    //             const form = atcBtn.closest("form") || document.querySelector("form[action='/cart/add']");
    //             if (form) {
    //                 form.submit();
    //             } else {
    //                 atcBtn.classList.remove("is-loading");
    //                 atcBtn.style.pointerEvents = "auto";
    //                 atcBtn.style.opacity = "1";
    //                 atcBtn.innerHTML = atcBtn.dataset.originalHtml;
    //             }
    //         }
    //     });
    // }

    // HB edit
    handleAddToCart() {
        const atcBtn = document.getElementById("btn-atc");
        if (!atcBtn) return;

        const resetBtn = () => {
            atcBtn.classList.remove("is-loading");
            atcBtn.style.pointerEvents = "auto";
            atcBtn.style.opacity = "1";
            if (atcBtn.dataset.originalHtml) {
                atcBtn.innerHTML = atcBtn.dataset.originalHtml;
            }
        };

        atcBtn.addEventListener("click", (e) => {
            if (atcBtn.classList.contains("is-loading")) {
                e.preventDefault();
                return;
            }

            atcBtn.dataset.originalHtml = atcBtn.innerHTML;
            atcBtn.classList.add("is-loading");
            atcBtn.style.pointerEvents = "none";
            atcBtn.style.opacity = "0.7";
            atcBtn.innerHTML = `
                <svg class="spinner" viewBox="0 0 50 50" style="width:20px;height:20px;vertical-align:middle;">
                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                <span>Adding...</span>
            `;

            // safety timeout - never leave user stuck
            const safetyTimeout = setTimeout(() => resetBtn(), 8000);

            const form = atcBtn.closest("form") || document.querySelector("form[action='/cart/add']");
            const originalAtc = document.querySelector(".hulkapps_submit_cart, .product-form__submit, button[name='add']");

            const onCartUpdate = () => {
                clearTimeout(safetyTimeout);
                setTimeout(() => resetBtn(), 500);
                document.removeEventListener("cart:updated", onCartUpdate);
                document.removeEventListener("items-added.cart", onCartUpdate);
            };

            // Listen for common Shopify theme cart events
            document.addEventListener("cart:updated", onCartUpdate, { once: true });
            document.addEventListener("items-added.cart", onCartUpdate, { once: true });

            if (form) {
                try {
                    // requestSubmit() respects submit event listeners and works with
                    // Shopify's AJAX cart — preferred over .click() on Safari
                    if (typeof form.requestSubmit === "function") {
                        form.requestSubmit(originalAtc || undefined);
                    } else {
                        // Fallback for older Safari (< 16)
                        if (originalAtc) {
                            originalAtc.dispatchEvent(new MouseEvent("click", {
                                bubbles: true,
                                cancelable: true,
                                view: window
                            }));
                        } else {
                            form.submit();
                        }
                    }
                } catch (err) {
                    console.warn("ATC submission error:", err);
                    clearTimeout(safetyTimeout);
                    resetBtn();
                }
            } else {
                clearTimeout(safetyTimeout);
                resetBtn();
            }
        });
    }
}

new HulkBuilder().init();